import React, { useState, useEffect, useRef } from "react";
import HomeOutlined from "@mui/icons-material/HomeOutlined";
import FolderSpecialOutlined from "@mui/icons-material/FolderSpecialOutlined";
import PersonAddAlt1Outlined from "@mui/icons-material/PersonAddAlt1Outlined";
import MedicalInformationOutlined from "@mui/icons-material/MedicalInformationOutlined";
import EventAvailableOutlined from "@mui/icons-material/EventAvailableOutlined";
import PowerSettingsNewSharpIcon from '@mui/icons-material/PowerSettingsNewSharp';
import {
  Layout,
  Menu,
  Avatar,
  Button,
  Dropdown,
  Input,
  Space,
} from "antd";
import {
  UserOutlined,
  MenuOutlined,
  BellOutlined,
  DownOutlined,
  SearchOutlined,
  CheckSquareOutlined
} from "@ant-design/icons";
import { useNavigate, Outlet } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner"; // Path checked as per current components
import "./Dashboard.css";

const { Header, Sider, Content } = Layout;

const DashboardPage = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState("home");
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate();
  const containerRef = useRef(null);

  useEffect(() => {
    const storedRole = localStorage.getItem("userRole");
   if (!storedRole) { navigate("/admin"); }
  }, [navigate]);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setMobileOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 🎯 Direct Layout Management — Subsidebars पूर्णपणे उडवून डायरेक्ट नेव्हिगेशन केलं!
  const handleMainIconClick = (menu, path) => {
    setActiveMenu(menu);
    handleNavigation(`/dashboard/${path}`);
    if (isMobile) {
      setMobileOpen(false);
    }
  };

  const handleNavigation = (path) => {
    setLoading(true);
    setTimeout(() => {
      navigate(path);
      setLoading(false);
    }, 1000); 
  };

  const handleToggleMobile = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleLogout = () => {
  localStorage.clear(); navigate("/admin");
  };

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100vh",
        display: "flex",
        backgroundColor: "#eff6fe",
        border: `${isMobile ? 5 : 8}px solid rgb(11, 80, 126)`,
        borderRadius: "12px",
        boxSizing: "border-box",
        overflow: "hidden",
        zIndex: 1,
      }}
    >
      
      {loading && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(255,255,255,0.7)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}>
          <LoadingSpinner />
        </div>
      )}

      <Layout style={{ minHeight: "100%", position: "relative" }}>
        
        {/* Left Primary Single-Layer MLM Sider bar */}
        <Sider
          width={60}
          style={{
            background: "#ffffff",
            color: "black",
            zIndex: 10,
            boxShadow: "2px 0 10px rgba(0,0,0,0.15)",
            display: "flex",
            flexDirection: "column",
            position: isMobile ? "absolute" : "sticky",
            top: 0,
            left: isMobile ? (mobileOpen ? 0 : -60) : 0,
            height: "100%",
            transition: "left 0.4s ease",
          }}
        >
          <div className="logo-container">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.jpg`}
              alt="Logo"
              style={{ width: "50px", margin: "10px auto", display: "block", borderRadius: "50%" }}
            />
          </div>

          <div className="sider-icons-container" style={{ display: "flex", flexDirection: "column", gap: "10px", marginTop: "10px" }}>
            {/* 🛠️ Direct Path Binding: MLM च्या गरजेनुसार सुटसुटीत मॅपिंग */}
            {[
              { key: "home", path: "home", icon: <HomeOutlined />, title: "Dashboard" },
              { key: "registration", path: "registration", icon: <PersonAddAlt1Outlined />, title: "Registration" },
              { key: "members", path: "member-list", icon: <MedicalInformationOutlined />, title: "Account History" },
              // { key: "package-master", path: "package-master", icon: <EventAvailableOutlined />, title: "Package Master" },
              // { key: "report", path: "reports", icon: <FolderSpecialOutlined />, title: "Reports" },
            ].map((item) => (
              <div
                key={item.key}
                className={`main-icon ${activeMenu === item.key ? "active" : ""}`}
                onClick={() => handleMainIconClick(item.key, item.path)}
                title={item.title}
                style={{ width: "45px", height: "45px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto", borderRadius: "8px", cursor: "pointer", transition: "all 0.3s" }}
              >
                {item.icon}
              </div>
            ))}
          </div>
        </Sider>

        {/* Core Content Area Layout */}
        <Layout style={{ marginLeft: 0, transition: "all 0.3s", width: "100%" }}>
          <Header style={{ background: "#ffffff", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between", height: "65px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)", position: "sticky", top: 0, zIndex: 5 }}>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {isMobile && <Button type="text" icon={<MenuOutlined style={{ fontSize: 20 }} />} onClick={handleToggleMobile} />}
             
              
            </div>

            <Space size="middle" style={{ display: "flex", alignItems: "center" }}>
              {!isMobile && <>
                {/* <Button type="text" icon={<CheckSquareOutlined style={{ fontSize: 18, color: "#037589ff" }} />} />
                <Button type="text" icon={<BellOutlined style={{ fontSize: 18, color: "#037589ff" }} />} /> */}
              </>}
              <Avatar icon={<UserOutlined style={{ fontSize: isMobile ? 18 : 25 }} />} style={{ backgroundColor: "#037589ff", width: isMobile ? 28 : 36, height: isMobile ? 28 : 36 }} />
              <Button type="text" onClick={handleLogout} title="Logout" style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", padding: 0, background: "none", border: "none" }}>
                <PowerSettingsNewSharpIcon style={{ fontSize: isMobile ? 24 : 28, cursor: "pointer", color: "#037589ff" }} />
              </Button>
            </Space>
          </Header>

          {/* Display Router Outlet */}
          <Content style={{ position: "relative", zIndex: 1, height: "calc(100vh - 65px)", overflow: "hidden", background: "#f8fafc" }}>
           <div style={{ height: "100%", overflowY: "auto", padding: "0", background: "#fff", boxSizing: "border-box" }} className="scroll-wrapper">
              <Outlet />
            </div>
          </Content>
        </Layout>

      </Layout>
    </div>
  );
};

export default DashboardPage;